import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import {
  ListarCodPostalDto,
  ListarMunicipioRequest,
  ListarPobCodPostalRequest,
  ListarPoblacionDto,
  ListarPoblacionRequest,
  ListarTiposViaDto,
  ListarViaDto,
  ListarViaRequest,
  NormalizarDomicilioDto,
  NormalizarNombreDto,
  NormalizarPoblacionDto,
  NormalizarRestoDomicilioDto,
  NormalizarViaDto,
  NormDomicilioRequest,
  NormNombreRequest,
  NormPobRequest,
  NormRestoDomicilioRequest,
  NormViaRequest,
  PFValidarEmailDto,
  PFValidarEmailRequest,
  ValidarTelefonoDto,
  ValidarTelefonoRequest,
} from '../model/geocode-model';

@Injectable()
export class GeocodeApi {
  constructor(private _http: HttpClient) {}

  getListPopulation(listPopulationRequest: ListarPoblacionRequest): Observable<ListarPoblacionDto[]> {
    return this._http.post<ListarPoblacionDto[]>(
      environment.URL_GEOCODE + environment.subUrlListPopulation,
      listPopulationRequest
    );
  }

  getListPopulationCodPostal(listPobCodPostalRequest: ListarPobCodPostalRequest): Observable<ListarCodPostalDto[]> {
    return this._http.post<ListarCodPostalDto[]>(
      environment.URL_GEOCODE + environment.subUrlListPopulationCodPostal,
      listPobCodPostalRequest
    );
  }

  getListMunicipios(listMunicipioRequest: ListarMunicipioRequest) {
    return this._http.post<ListarPoblacionDto[]>(
      environment.URL_GEOCODE + environment.subUrlListMunicipio,
      listMunicipioRequest
    );
  }

  getListTypeVia() {
    return this._http.get<ListarTiposViaDto[]>(environment.URL_GEOCODE + environment.subUrlListTypesVia);
  }

  getListVia(listViaRequest: ListarViaRequest): Observable<ListarViaDto[]> {
    return this._http.post<ListarViaDto[]>(environment.URL_GEOCODE + environment.subUrlListVia, listViaRequest);
  }

  postNormalizarDomicilio(normDomicilioRequest: NormDomicilioRequest) {
    return this._http.post<NormalizarDomicilioDto>(
      environment.URL_GEOCODE + environment.subUrlNormalizarDomicilio,
      normDomicilioRequest
    );
  }

  postNormalizarRestoDomicilio(normRestoDomicilioRequest: NormRestoDomicilioRequest) {
    return this._http.post<NormalizarRestoDomicilioDto>(
      environment.URL_GEOCODE + environment.subUrlNormalizarRestoDomicilio,
      normRestoDomicilioRequest
    );
  }

  postValidarEmail(validarEmailRequest: PFValidarEmailRequest) {
    return this._http.post<PFValidarEmailDto>(
      environment.URL_GEOCODE + environment.subUrlValidarEmail,
      validarEmailRequest
    );
  }

  postValidarTelefono(validarTelefonoRequest: ValidarTelefonoRequest) {
    return this._http.post<ValidarTelefonoDto>(
      environment.URL_GEOCODE + environment.subUrlValidarTelefono,
      validarTelefonoRequest
    );
  }

  postNormalizarNombre(normalizarNombreRequest: NormNombreRequest) {
    return this._http.post<NormalizarNombreDto>(
      environment.URL_GEOCODE + environment.subUrlNormalizarNombre,
      normalizarNombreRequest
    );
  }

  postNormalizarPoblacion(normalizarPoblacionRequest: NormPobRequest) {
    return this._http.post<NormalizarPoblacionDto>(
      environment.URL_GEOCODE + environment.subUrlNormalizarPoblacion,
      normalizarPoblacionRequest
    );
  }

  postNormalizarVia(normalizarViaRequest: NormViaRequest) {
    return this._http.post<NormalizarViaDto>(
      environment.URL_GEOCODE + environment.subUrlNormalizarVia,
      normalizarViaRequest
    );
  }
}
